/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */
import {ActionTree} from 'vuex';
import {RootState} from '@/store/types';
import {VoteStateInterface} from '@/store/modules/vote/types';

export const actions: ActionTree<VoteStateInterface, RootState> = {
};
